import { render, staticRenderFns } from "./CancelOrderDialog.vue?vue&type=template&id=66b16420&"
import script from "./CancelOrderDialog.vue?vue&type=script&lang=js&"
export * from "./CancelOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports